import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentLoading: {
        id: 'billing.paymentinfo.Your payment is processing. Please do not press the back button or close your browser.',
        defaultMessage: 'Your payment is processing. Please do not press the back button or close your browser.'
    },
    paymentDeclineMessage: {
        id: 'billing.paymentinfo.paymentDeclineMessage',
        defaultMessage: 'Credit card payment was not processed. Please confirm the card information and billing address before trying again.'
    },
    paymentDeclineInstruction: {
        id: 'billing.paymentinfo.paymentDeclineInstruction',
        defaultMessage: 'If problems continue, you may contact us at PortalAdmin@copperpoint.com.'
    },
});